import React, { Suspense } from 'react';
import { BrowserRouter, Route, Routes, useInRouterContext } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import HomePage from './pages/HomePage';
import ScrollToTop from './components/ScrollToTop';
import AnalyticsPageViews from './components/AnalyticsPageViews';
import CookieConsent from './components/CookieConsent';
import { lazyPages } from './routes/lazyPages';

function PageFallback() {
  return <main className="min-h-screen bg-[#FAF8F5]" aria-busy="true" />;
}

// `pages` is passed only by the SSR entry so prerendering can render routes synchronously.
function AppContent({ pages }) {
  const routes = pages ? { ...lazyPages, ...pages } : lazyPages;
  const {
    ListiclePage,
    DirectoryPage,
    AboutPage,
    NotFoundPage,
    PrivacyPolicy,
    TermsOfService,
    Disclaimer,
    AdminLayout,
    AdminDashboard,
    AdminEditor,
    AdminBulkUpload
  } = routes;

  return (
    <>
      <ScrollToTop />
      <AnalyticsPageViews />
      <Suspense fallback={<PageFallback />}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/directory" element={<DirectoryPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/courses/:slug" element={<ListiclePage />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="create" element={<AdminEditor />} />
            <Route path="edit/:id" element={<AdminEditor />} />
            <Route path="bulk-upload" element={<AdminBulkUpload />} />
          </Route>
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
      <CookieConsent />
    </>
  );
}

function App({ pages }) {
  const inRouter = useInRouterContext();
  const content = inRouter
    ? <AppContent pages={pages} />
    : (
      <BrowserRouter>
        <AppContent pages={pages} />
      </BrowserRouter>
    );

  return pages ? content : <HelmetProvider>{content}</HelmetProvider>;
}

export default App;